import React from 'react';
import { Avatar, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { string, shape } from 'prop-types';
import I18n from 'i18n-js';

const { Text } = Typography;

const RouteItem = ({
  fromAssignee = { username: '', avatarUrl: '' },
  toAssignee = { username: '', avatarUrl: '' },
  changedBy = { username: '', avatarUrl: '' },
  createdAt = '',
}) => (
  <div className="ticket-route-item">
    <div className="ticket-route-item__header">
      <Avatar
        className="ticket-route-item__header-avatar"
        src={changedBy.avatarUrl}
      />
      <div className="ticket-route-item__header-info">
        <Text className="ticket-route-item__changed-by">
          {changedBy.username} {I18n.t('ticket_routes.activity.changed_assignee')}
        </Text>
        <br />
        <Text className="ticket-route-item__created-at">{createdAt}</Text>
      </div>
    </div>

    <div className="ticket-route-item__body">
      <Avatar
        className="ticket-route-item__body-avatar"
        src={fromAssignee.avatarUrl}
        size="small"
      />
      <Text>{fromAssignee.username}</Text>
      <ArrowRightOutlined className="ticket-route-item__body-arrow" />
      <Avatar
        className="ticket-route-item__body-avatar"
        src={toAssignee.avatarUrl}
        size="small"
      />
      <Text>{toAssignee.username}</Text>
    </div>
  </div>
);

RouteItem.propTypes = {
  fromAssignee: shape({ username: string, avatarUrl: string }),
  toAssignee: shape({ username: string, avatarUrl: string }),
  changedBy: shape({ username: string, avatarUrl: string }),
  createdAt: string,
};

export default RouteItem;
